import { render, staticRenderFns } from "./adminRoomList.vue?vue&type=template&id=2a272a61&scoped=true"
import script from "./adminRoomList.vue?vue&type=script&lang=js"
export * from "./adminRoomList.vue?vue&type=script&lang=js"
import style0 from "./adminRoomList.vue?vue&type=style&index=0&id=2a272a61&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a272a61",
  null
  
)

export default component.exports